import { useCallback, useState } from 'react'

export const useSessionStorage = (key, initialValue) => {
    const [value, setValueState] = useState(() => {
        if (typeof window === 'undefined') return initialValue
        try {
            const item = window.sessionStorage.getItem(key)
            return item ? JSON.parse(item) : initialValue
        } catch (error) {
            console.error(`Ошибка чтения из sessionStorage для ключа "${key}":`, error)
            return initialValue
        }
    })

    const setValue = useCallback(
        (val) => {
            try {
                setValueState((prev) => {
                    const valToStore = val instanceof Function ? val(prev) : val
                    window.sessionStorage.setItem(key, JSON.stringify(valToStore))
                    return valToStore
                })
            } catch (error) {
                console.error(`Ошибка записи в sessionStorage для ключа "${key}":`, error)
            }
        },
        [key],
    )

    return [value, setValue]
}
